import { render, staticRenderFns } from "./FormMoney.vue?vue&type=template&id=b5bebd68&scoped=true&"
import script from "./FormMoney.vue?vue&type=script&lang=js&"
export * from "./FormMoney.vue?vue&type=script&lang=js&"
import style0 from "./FormMoney.vue?vue&type=style&index=0&id=b5bebd68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bebd68",
  null
  
)

export default component.exports